/**
 * Console — top-level orchestrator. Google sign-in is the auth boundary:
 *   - restoring session → quiet loading state
 *   - not authenticated → split-screen Login (Google sign-in)
 *   - authenticated     → console shell (Analytics · Vault Control)
 *
 * Wallet connection happens inside the console (header) for vault actions.
 */

import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/Brand";
import Login from "../components/Login";
import Dashboard from "../components/Dashboard";
import { WalletGate } from "../components/WalletGate";

export default function Console() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}>
        <div style={{ textAlign: "center" }}>
          <div className="pop">
            <Logo size={34} />
          </div>
          <div className="mono fade d2" style={{ marginTop: 22, fontSize: 12, letterSpacing: "0.14em", color: "var(--micro)" }}>
            LOADING CONSOLE…
          </div>
          <div style={{ width: 180, height: 3, background: "var(--bg-3)", borderRadius: 9, margin: "18px auto 0", overflow: "hidden" }}>
            <div style={{ height: "100%", width: "40%", background: "var(--accent)", borderRadius: 9, animation: "loadbar 1.1s var(--smooth) infinite" }} />
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Login />;
  // Signed in, but nothing is reachable until the user connects (and thereby
  // claims / matches) their deposit wallet — a hard, full-screen gate.
  return (
    <WalletGate>
      <Dashboard />
    </WalletGate>
  );
}
